// The tracker's narrow presentation: one tile per row, for a phone.
//
// The table scrolls sideways by design and never fits, so on a phone it is a box a few hundred
// pixels wide in which the identifier scrolls out of view first - the defect the deal register's
// tiles fixed. A tile leads with the identifier, then the columns the row has a value for in the
// column order the API serves, derived values in the table's derived treatment, the creation
// date last, and the same edit and delete controls in the same place a table row has them.
//
// The sort control is ui/TileSort.jsx, offered the same list the table's headers are, and the
// filter control is TileFilter.jsx beside it. The total row (TX-US-0017) is a tile at the top - a
// foot under a column of tiles is off-screen - with the same content the table's foot has.

import AttachmentBadge from './attachments/AttachmentBadge.jsx';
import { cellClass, display } from './cells.js';
import RowActions from './RowActions.jsx';
import TileSort from '../ui/TileSort.jsx';
import { totalLabel } from './DeliveryTable.jsx';
import TileFilter from './TileFilter.jsx';
import { sortOptions } from './trackerUrl.js';

export default function DeliveryTiles({
  leg, columns, rows, totals, query, url, onSort, onFilter, canWrite, onDelete, onAttachments,
}) {
  return (
    <>
      <TileSort options={sortOptions(columns)} query={query} onSort={onSort} />
      <TileFilter leg={leg} columns={columns} query={query} url={url} onFilter={onFilter} />

      <ul className="deal-tiles">
        {totals && (
          <li className="total-tile">
            <div className="deal-tile-head"><strong>{totalLabel(totals)}</strong></div>
            <dl className="deal-tile-fields">
              {columns.map((column) => (
                <Field key={column.key} column={column}>{totals.totals[column.key]}</Field>
              ))}
            </dl>
          </li>
        )}
        {rows.map((row) => (
          <li key={row.delivery_id} className="deal-tile">
            <div className="deal-tile-head">
              <code>{row.delivery_id}</code>
              <span className="row-actions">
                <AttachmentBadge row={row} onOpen={onAttachments} />
                {canWrite && <RowActions leg={leg} row={row} onDelete={onDelete} />}
              </span>
            </div>

            <dl className="deal-tile-fields">
              {columns.map((column) => (
                <Field key={column.key} column={column}>
                  {column.derived ? row.derived[column.key] : display(column, row.values[column.key])}
                </Field>
              ))}
            </dl>

            <p className="deal-tile-when">{new Date(row.created_at).toLocaleDateString()}</p>
          </li>
        ))}
      </ul>
    </>
  );
}

// A blank column is omitted rather than rendered as a label with nothing after it: twenty labels
// with a handful of values between them would be most of the tile.
function Field({ column, children }) {
  if (children === '' || children === null || children === undefined) return null;
  const derived = column.derived ? 'derived' : undefined;
  return (
    <>
      <dt className={derived} title={column.note ?? undefined}>
        {column.label}{column.note && ' *'}
      </dt>
      <dd className={derived ?? cellClass(column)}>{children}</dd>
    </>
  );
}
